<template>
    <div>
        <el-dialog title="驳回原因" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
            <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="form.reject_reason">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="savereject(form.id)"
                    style="background-color: #006E4B; border-color: #006E4B;">确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog title="同意原因" :visible.sync="dialogVisibleok" width="30%" :before-close="handleClose">
		    <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="form.reject_reason">
		    </el-input>
		    <span slot="footer" class="dialog-footer">
		        <el-button type="primary" @click="saveok(form.id)"
		            style="background-color: #006E4B; border-color: #006E4B;">确 定</el-button>
		    </span>
		</el-dialog>
    </div>
</template>

<script>
    export default {
        props: ["editData", "id","spare"],
        data() {
            return {
                dialogVisible: false,
				dialogVisibleok: false,
                form: {
                    id: "",
                    reject_reason: "",
                }
            };
        },
        methods: {
            //驳回
            reject(e) {
                this.form.id = e;
                this.form.reject_reason = "";
                this.dialogVisible = true;
            },
			save(id,e){
				this.form.id = e;
				this.form.reject_reason = "";
				this.dialogVisibleok = true;
			},
			//驳回提交
			async savereject() { 
			    var url = "examine/modify";
			    var record = {
			        id: this.id,
			        reviewer_state: 2,
			        reject_reason: this.form.reject_reason,
					applicant_id: this.$globals.user.staff_id,
					spare5: this.spare,
			    };
			    var data = await this.$globals.AxiosPost(url, record);
			    if (data === '-2000') {
			        this.$message.error('服务器未响应！请稍后重试');
			    } else {
			        var code = data.code;
			        var data = data.data;
			        if (code === '200') {
			            this.$message.success(data);
			            this.dialogVisible = false;
			            this.$parent.Return();
			        } else {
			            this.$message.warning(data);
			        }
			    }
			},
            //同意提交
            async saveok() {
                var url = "examine/modify";
                var record = {
                    id: this.id,
                    reviewer_state: 1,
                    reject_reason: this.form.reject_reason,
					applicant_id: this.$globals.user.staff_id,
					spare5: this.spare,
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.dialogVisibleok = false;
                        this.$parent.Return();
                    } else {
                        this.$message.warning(data);
                    }
                }
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// OA_examine.vue?95b081b6